import { gql } from '@apollo/client'
import { useCleanFilterForRequest, useSearch, useSort } from '@btime/react-contexts'
import React from 'react'

import { serviceOrdersClient } from '../../../../utils/apollo/api'
import { usePaginatedQuery } from '../../../../utils/apollo/_helpers/pagination'
import StatePresenter from '../../../../packages/kiti/components/helpers/StatePresenter'
import { useTranslation } from 'react-i18next'

const Context = React.createContext()
const { Provider } = Context
export const useStatusesState = () => React.useContext(Context) || {}
export const useStatuses = () => useStatusesState()?.statuses || []

const translatedStatuses = (data, t) => {
  if (!data) return []
  const result = data.statuses.map(status => {
    return { ...status, label: t('status.' + status.name) }
  })
  return { statuses: result }
}

const QUERY = gql`
  query Statuses($page: Int, $search: String, $sort: ServiceOrderStatusSort, $filter: ServiceOrderStatusFilter) {
    statuses(page: $page, search: $search, sort: $sort, filter: $filter, limit: 50) {
      id
      name
      label
      color
      deleted
    }
  }
`

const StatusesLoader = ({ children, uncontrolledChildren }) => {
  const { field, type } = useSort()
  const search = useSearch()
  const filter = useCleanFilterForRequest()
  const { t } = useTranslation('common')

  const { data, fetchMore, variables, ...state } = usePaginatedQuery(QUERY, {
    variables: {
      page: 1,
      search,
      sort: { field: field || 'ID', type },
      filter: filter
    },
    fetchPolicy: 'cache-first',
    client: serviceOrdersClient
  })

  return (
    <Provider value={translatedStatuses(data, t)}>
      <StatePresenter {...state} uncontrolledChildren={uncontrolledChildren}>
        {children}
      </StatePresenter>
    </Provider>
  )
}

export default StatusesLoader
